import b from "@emotion/styled/base";
import { Text as c } from "../../../Text/index.js";
const d = /* @__PURE__ */ b(c, process.env.NODE_ENV === "production" ? {
  target: "ebs4hv0"
} : {
  target: "ebs4hv0",
  label: "StyledNotice"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGV4dElucHV0L3N1YkNvbXBvbmVudHMvTm90aWNlL05vdGljZS5zdHlsZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXdDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGV4dElucHV0L3N1YkNvbXBvbmVudHMvTm90aWNlL05vdGljZS5zdHlsZWQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi8uLi8uLi9UZXh0JztcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5vdGljZSA9IHN0eWxlZChUZXh0KWBgO1xuIl19 */");
export {
  d as StyledNotice
};
